import React, { FC, useMemo, useState } from "react";
import "./Specs.scss";
import { HelloProduct } from "../../types/backend";
import {
  BsChevronDown,
  BsChevronLeft,
  BsChevronRight,
  BsChevronUp,
} from "react-icons/bs";
import { findBgSettings } from "../../utils/appSettings";

interface SpecsProps {
  product: HelloProduct;
  specsVisible: boolean;
  setSpecsVisible: React.Dispatch<React.SetStateAction<boolean>>;
  isFeaturesActive: boolean;
}

const ChevronIcon = ({ isVisible }: { isVisible: boolean }) => {
  const isMobile = window.innerWidth <= 600;

  if (isMobile) {
    return isVisible ? (
      <BsChevronDown fontSize={32} />
    ) : (
      <BsChevronUp fontSize={32} />
    );
  } else {
    return isVisible ? (
      <BsChevronRight fontSize={32} />
    ) : (
      <BsChevronLeft fontSize={32} />
    );
  }
};

const Specs: FC<SpecsProps> = ({
  product,
  specsVisible,
  setSpecsVisible,
  isFeaturesActive,
}) => {
  const toggleVisibility = () => {
    setSpecsVisible(!specsVisible);
  };

  const bgData = useMemo(() => {
    return findBgSettings(product);
  }, [product]);

  return (
    <>
      {!isFeaturesActive && (
        <div
          className={`toggle-button-container ${specsVisible ? "visible" : ""}`}
        >
          <button onClick={toggleVisibility} className="toggle-button">
            <ChevronIcon isVisible={specsVisible} />
          </button>
        </div>
      )}

      <div
        id={`helloar-${product._id}`}
        className={`specs-container ${
          specsVisible ? "visible" : ""
        } helloar-background`}
      >
        <>
          <h1>{product.name}</h1>
          <p className="specs-description">{product.description}</p>
        </>
      </div>
    </>
  );
};

export default Specs;
